import { useIsCreativeLibraryModule } from 'modules/creative-library/hooks/useIsCreativeLibraryModule';
import { FEATURE_FLAGS, useConfigMatch } from 'modules/taboola-common-frontend-modules/account-configurations';
import { queryParamHookFactory } from 'modules/taboola-common-frontend-modules/query-params';

export const IS_CREATIVE_LIBRARY = 'isCreativeLibrary';

const useCreativeLibraryQueryParam = queryParamHookFactory(IS_CREATIVE_LIBRARY);

export const useIsCreativeLibrary = () => {
    const [isCreativeLibraryCampaign] = useCreativeLibraryQueryParam();
    const isCreativeLibraryEnabled = useConfigMatch({ [FEATURE_FLAGS.CREATIVE_LIBRARY_ENABLED]: 'true' });
    const isCreativeLibraryModule = useIsCreativeLibraryModule();

    return {
        isCreativeLibraryEnabled,
        isCreativeLibraryCampaign,
        isCreativeLibraryModule,
    };
};
